import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAddNewState,
  selectCurrentTable,
  setAddNewState,
} from "../../store/slices/dataTablesSlice";
import "./TablesBasePage.scss";

export function TableTitle(props) {
  const { titles, tableTitle, onSelectedChanged, functions } = props;
  const title = tableTitle; //useSelector(selectCurrentTable);
  const addNewState = useSelector(selectAddNewState);
  const { t } = useTranslation(["translation", "tables"]);
  const dispatch = useDispatch();

  function handleOnChange(e) {
    let res = titles?.find((item) => item.title === e.target.value)?.title || "notfound";
    if (res !== "notfound") {
      dispatch(setAddNewState(false));
      onSelectedChanged(res);
    }
  }
  useEffect(() => {}, [title]);

  return (
    <div className="table-title">
      <select
        value={title}
        style={{
          border: "none",
          backgroundColor: "transparent",
          fontSize: 20,
        }}
        onChange={(e) => {
          handleOnChange(e);
        }}
      >
        {titles?.map((item, index) => {
          return (
            <option key={`title${index}`} value={item.title}>
              {t(`tables.${item.title}`, { ns: "tables" })}
            </option>
          );
        })}
      </select>
      {!titles && <span>{title}</span>}
      {functions?.getNew && (
        <div className="btn-group">
          <button
            className="btn"
            style={{ marginTop: "-9px" }}
            onClick={() => {
              dispatch(setAddNewState(!addNewState));
            }}
            disabled={functions?.getNew === undefined}
          >
            <FontAwesomeIcon
              id="clickableAwesomeFont"
              data-toggle="tooltip"
              title="Add new"
              fontSize={32}
              color={"green"}
              icon={faCirclePlus}
              className="mx-2"
            />
          </button>
        </div>
      )}
    </div>
  );
}
